import loadable from '@loadable/component';

export const LazyWorkspace = loadable(() => import(/* webpackChunkName: "content/workspace" */ './Workspace'));
